"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabList = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../Tabs/index.js");
var _TabList = require("./TabList.js");
var _index2 = require("../../styles/index.js");
var _index3 = require("../../styles/mixins/OverflowButton/index.js");
var _utils = require("../../utils.js");
var _excluded = ["children", "onKeyDown", "contentAlign"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * TabList is a container for TabItems.
 *
 * This component is meant to be used in conjunction with the other Tab components. Please refer to {@link https://encore-web.spotify.net/?path=/docs/components-tabs--docs Tabs} for a more complete example.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-tabs-tablist--docs) |
 * [Encore site](https://encore.spotify.net/web/components/tabs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TabList)
 */
var TabList = exports.TabList = /*#__PURE__*/_react["default"].forwardRef(function TabList(_ref, ref) {
  var children = _ref.children,
    _onKeyDown = _ref.onKeyDown,
    contentAlign = _ref.contentAlign,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var tabListRef = (0, _react.useRef)(null);
  var _useContext = (0, _react.useContext)(_index.TabsContext),
    handleKeyDown = _useContext.handleKeyDown;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showOverflowStartButton = _useState2[0],
    setShowOverflowStartButton = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showOverflowEndButton = _useState4[0],
    setShowOverflowEndButton = _useState4[1];
  var handleOverflowButtons = (0, _react.useCallback)(function () {
    if (tabListRef.current) {
      var scrollLeft = Math.abs(tabListRef.current.scrollLeft);
      var visibleWidth = tabListRef.current.offsetWidth;
      var totalWidth = tabListRef.current.scrollWidth;
      // not normally supposed to use controlSizeFallback directly, but need to here
      // b/c we can't compare use a CSS variable to compare to the scroll value
      var buttonWidth = parseInt(_index2.controlSizeFallback.medium, 10);
      if (scrollLeft > buttonWidth) {
        setShowOverflowStartButton(true);
      } else {
        setShowOverflowStartButton(false);
      }
      if (scrollLeft + visibleWidth + buttonWidth < totalWidth) {
        setShowOverflowEndButton(true);
      } else {
        setShowOverflowEndButton(false);
      }
    }
  }, [tabListRef]);
  var scrollToDir = function scrollToDir(direction) {
    if (tabListRef.current) {
      var _tabListRef$current;
      var scrollLeft = tabListRef.current.scrollLeft;
      var visibleWidth = tabListRef.current.offsetWidth;
      var left = direction === 'start' ? scrollLeft - visibleWidth / 1.25 : scrollLeft + visibleWidth / 1.25;
      (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 || _tabListRef$current.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleOverflowButtons);
    handleOverflowButtons();
    return function () {
      return window.removeEventListener('resize', handleOverflowButtons);
    };
  }, [handleOverflowButtons]);
  var ltr = (0, _utils.isLtr)(tabListRef);
  return /*#__PURE__*/_react["default"].createElement(_TabList.Container, null, /*#__PURE__*/_react["default"].createElement(_index3.OverflowButton, {
    position: "start",
    show: showOverflowStartButton,
    onClick: function onClick() {
      return scrollToDir(ltr ? 'start' : 'end');
    }
  }), /*#__PURE__*/_react["default"].createElement(_TabList.StyledTabList, Object.assign({
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TabList,
    role: "tablist",
    ref: (0, _utils.mergeRefs)([tabListRef, ref]),
    onScroll: handleOverflowButtons,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, _onKeyDown);
    },
    $showStartOverflow: showOverflowStartButton,
    $showEndOverflow: showOverflowEndButton,
    $contentAlign: contentAlign
  }, props), children), /*#__PURE__*/_react["default"].createElement(_index3.OverflowButton, {
    position: "end",
    show: showOverflowEndButton,
    onClick: function onClick() {
      return scrollToDir(ltr ? 'end' : 'start');
    }
  }));
});